<template>
  <div>
    <div class="row">
      <div class="col-full">
        <al-input
          key="register-email-input"
          v-model="form.email"
          v-validate="'required|email'"
          :label="$t('placeholder.email')"
          autocomplete="email"
          type="email"
          name="userId"
          data-test="user-id"
          @input="input" />
      </div>
    </div>
    <div class="row">
      <div class="col-full">
        <al-contact-input
          key="register-contact-input"
          v-model="form.phone"
          :countries="countryOptions"
          :label="$t('placeholder.mobileNumber')"
          :legal="$t('provisionCreate.mobileHelperText')"
          name="phoneNumber"
          @input="input" />
      </div>
    </div>
  </div>
</template>

<script>
import { AlContactInput, AlInput } from '@mc-alberta/alcapone'
import { mapState } from 'vuex'

export default {
  name: 'RegisterForm',
  components: { AlContactInput, AlInput },
  inject: ['$validator'],
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: {
    formData: {
      type: Object,
      default: Object
    }
  },
  data() {
    return {
      countryOptions: this.$i18nData.getPhonesConfig(),
      userId: '',
      form: {
        email: '',
        phone: {},
        ...this.formData
      }
    }
  },
  computed: {
    ...mapState({
      countryCode: (state) => state.user.consumer.countryCode
    })
  },
  watch: {
    countryCode: function (countryCode) {
      if (!this.fields.phoneNumber.dirty || this.fields.phoneNumber.untouched) {
        this.form.phone.country = countryCode
      }
    }
  },
  created() {
    if (!this.form.phone.countryCode) {
      this.form.phone.country = this.$store.state.user.consumer.countryCode
    }
  },
  methods: {
    input() {
      this.$emit('input', this.form)
    }
  }
}
</script>
